<!--==================================
=            ANALYTICINFO            =
===================================-->
<template>
  <!-- widgets3 -->
  <v-flex row ma-1>
    <!-- no 13 chart    -->
    <v-flex class="pa-3" xs12 md4 sm12>
    <v-card
    class=" text-center elevation-0"
    color="primary"
    dark

  >
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
        <v-sparkline
          :value="value"
          color="rgba(255, 255, 255, .7)"
          height="100"
          padding="24"
          stroke-linecap="round"
          smooth
        >
          <template v-slot:label="item">
            ${{ item.value }}
          </template>
        </v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="body-1 font-weight-bolder">Max Last 24h</div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>
  </v-card>
    </v-flex>

    <!-- no 14 chart -->
    <!-- no 15 chart -->
    <v-flex class="pa-3" xs12 md4 sm12>
    <v-card
    class=" text-center elevation-0"
    color="secondary"
    dark

  >
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
        <v-sparkline
          :value="value"
          color="rgba(255, 255, 255, .7)"
          height="100"
          padding="24"
          stroke-linecap="round"
          smooth
        >
          <template v-slot:label="item">
            ${{ item.value }}
          </template>
        </v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="body-1 font-weight-bolder">Timeline Last 24h</div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>
  </v-card></v-flex>
    <!-- no 16 chart-->

    <!-- no 15 chart -->
   <v-flex class="pa-3" xs12 md4 sm12>
    <v-card
    class=" text-center elevation-0"
    color="error"
    dark

  >
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
        <v-sparkline
          :value="value"
          color="rgba(255, 255, 255, .7)"
          height="100"
          padding="24"
          stroke-linecap="round"
          smooth
        >
          <template v-slot:label="item">
            ${{ item.value }}
          </template>
        </v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="body-1 font-weight-bolder">Social 24h</div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>
  </v-card>
    <!-- no 16 chart-->
  </v-flex></v-flex>
</template>
<style scoped></style>
<script>
export default {
  data: () => ({
    value: [423, 446, 675, 510, 590, 610, 760]
  })
};
</script>

<!--====  End of ANALYTICINFO  ====-->
